import React, { useEffect } from 'react';







const getMeasurements = (target, current) => {
  const parentTop = target.getBoundingClientRect().top;
  const scrollerTop = target.scrollTop;
  const stickyTop = current.offsetTop || 0;
  const stickyBottom = stickyTop + current.offsetHeight;
  return {
    scrollerTop,
    stickyTop,
    stickyBottom,
    parentTop
  };
};

const eventHandler = (self, stickyElementSelector, event) => {
  if (self && self.current && event.target && event.target instanceof Element) {
    const { current } = self;
    const stickyElement = current.querySelector(stickyElementSelector);
    current.classList.remove('sticky');
    const { scrollerTop, stickyTop, stickyBottom, parentTop } = getMeasurements(
    event.target,
    current);


    if (stickyTop < scrollerTop && stickyBottom > scrollerTop) {
      current.classList.add('sticky');
      if (stickyElement) {
        stickyElement.style.top = `${parentTop}px`;
      }
    }
  }
};

const StickyHeader = (props) => {
  const { children, scrollElementSelector, stickyElementSelector } = props;
  const self = /*#__PURE__*/React.createRef();
  const body = document.querySelector(scrollElementSelector);
  useEffect(() => {
    body === null || body === void 0 ? void 0 : body.addEventListener('scroll', (event) => {
      eventHandler(self, stickyElementSelector, event);
    });

    return () => {
      body === null || body === void 0 ? void 0 : body.removeEventListener('scroll', (event) =>
      eventHandler(self, stickyElementSelector, event));

    };
  });

  return /*#__PURE__*/React.createElement("div", { ref: self }, children);
};

export { StickyHeader };